<template>
  <div class="modal-mask">
    <div class="modal-wrapper">
      <div class="modal-container">
        <h3>{{ modalTitle }}</h3>
        <form @submit.prevent="submitForm">
          <div class="form-group">
            <label>{{ $t('name') }} <span class="text-danger">*</span></label>
            <input v-model="form.name" type="text" class="form-control" required>
          </div>

          <div class="form-group">
            <label>{{ $t('phone') }}</label>
            <input v-model="form.phone" type="text" class="form-control">
          </div>

          <div class="form-group">
            <label>{{ $t('email') }}</label>
            <input v-model="form.email" type="email" class="form-control">
          </div>

          <div class="form-group">
            <label>{{ $t('city') }} <span class="text-danger">*</span></label>
            <select v-model="form.city" class="form-control" required>
              <option value="">Select City</option>
              <option v-for="city in bangladeshDistricts" :key="city" :value="city">
                {{ city }}
              </option>
            </select>
          </div>

          <div class="form-group">
            <label>{{ $t('address') }}</label>
            <textarea v-model="form.address" class="form-control" rows="3"></textarea>
          </div>

          <div class="form-group">
            <label>{{ $t('project') }}</label>
            <select v-model="form.project_id" class="form-control">
              <option value="">Select Project</option>
              <option v-for="project in projects" :key="project.id" :value="project.id">
                {{ project.title }}
              </option>
            </select>
          </div>

          <div class="form-group">
            <label>{{ $t('subscription_type') }}</label>
            <select v-model="form.subscription_type" class="form-control">
              <option value="">Select Type</option>
              <option value="monthly">Monthly</option>
              <option value="yearly">Yearly</option>
              <option value="one-time">One-time</option>
            </select>
          </div>

          <div class="form-group">
            <label>{{ $t('fee') }}</label>
            <input v-model="form.fee" type="number" step="0.01" class="form-control">
          </div>

          <div class="form-group">
            <label>{{ $t('start_date') }}</label>
            <input v-model="form.start_date" type="date" class="form-control">
          </div>

          <div class="text-end mt-3">
            <button 
              class="btn btn-primary" 
              type="submit" 
              :disabled="isSubmitting">
              {{ isSubmitting ? $t('saving') + '...' : $t('save') }}
            </button>
            <button class="btn btn-secondary" type="button" @click="$emit('input', false)" :disabled="isSubmitting">
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: Boolean,
    client: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      form: {
        name: '',
        phone: '',
        email: '',
        city: '',
        address: '',
        project_id: '',
        subscription_type: '',
        fee: '',
        start_date: ''
      },
      projects: [],
      isSubmitting: false,
      bangladeshDistricts: [
        'Dhaka', 'Gazipur', 'Narayanganj', 'Tangail', 'Kishoreganj', 'Manikganj', 'Munshiganj', 'Narsingdi', 'Rajbari', 'Shariatpur', 'Faridpur', 'Gopalganj', 'Madaripur',
        'Chittagong', 'Cox\'s Bazar', 'Bandarban', 'Khagrachhari', 'Rangamati', 'Comilla', 'Feni', 'Brahmanbaria', 'Chandpur', 'Lakshmipur', 'Noakhali',
        'Sylhet', 'Moulvibazar', 'Habiganj', 'Sunamganj',
        'Rajshahi', 'Bogra', 'Joypurhat', 'Naogaon', 'Natore', 'Chapainawabganj', 'Pabna', 'Sirajganj',
        'Rangpur', 'Dinajpur', 'Gaibandha', 'Kurigram', 'Lalmonirhat', 'Nilphamari', 'Panchagarh', 'Thakurgaon',
        'Khulna', 'Bagerhat', 'Chuadanga', 'Jashore', 'Jhenaidah', 'Kushtia', 'Magura', 'Meherpur', 'Narail', 'Satkhira',
        'Barisal', 'Barguna', 'Bhola', 'Jhalokati', 'Patuakhali', 'Pirojpur',
        'Mymensingh', 'Jamalpur', 'Netrokona', 'Sherpur'
      ]
    }
  },
  watch: {
    client: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.form = {
            name: newVal.name || '',
            phone: newVal.phone || '',
            email: newVal.email || '',
            city: newVal.city || '',
            address: newVal.address || '',
            project_id: newVal.project_id || '',
            subscription_type: newVal.subscription_type || '',
            fee: newVal.fee || '',
            start_date: newVal.start_date ? newVal.start_date.slice(0, 10) : ''
          }
        } else {
          this.resetForm()
        }
      }
    }
  },
  computed: {
    modalTitle() {
      return this.client ? 'Edit Client' : 'Add Client'
    }
  },
  mounted() {
    this.fetchProjects()
  },
  methods: {
    fetchProjects() {
      axios.get('/clients/projects').then(res => {
        this.projects = res.data
      })
    },
    resetForm() {
      this.form = {
        name: '',
        phone: '',
        email: '',
        city: '',
        address: '',
        project_id: '',
        subscription_type: '',
        fee: '',
        start_date: ''
      }
    },
    submitForm() {
      this.isSubmitting = true
      const url = this.client ? `/clients/${this.client.id}` : '/clients'
      const method = this.client ? 'PUT' : 'POST'

      axios({
        method: method === 'PUT' ? 'POST' : 'POST',
        url: url,
        data: method === 'PUT' ? { ...this.form, _method: 'PUT' } : this.form
      })
        .then(() => {
          this.$emit('input', false)
          this.$emit('saved')
          this.resetForm()
        })
        .catch(err => {
          console.error(err)
          Swal.fire({
            title: 'Error!',
            text: 'Error saving client information.',
            icon: 'error',
            confirmButtonColor: '#3085d6'
          })
        })
        .finally(() => {
          this.isSubmitting = false
        })
    }
  }
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0; left: 0; right: 0; bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal-wrapper {
  width: 600px;
  max-height: 90vh;
  overflow-y: auto;
  background: #fff;
  padding: 20px;
  border-radius: 6px;
}
</style>

